// extracted by mini-css-extract-plugin
export var sliderRange = "_pi-2";
export var sliderRoot = "_pi-0";
export var sliderThumb = "_pi-3";
export var sliderTrack = "_pi-1";